import * as React from "react";

import Text from "app/components/Text";
import LogoSVG from "app/components/shared/LogoSVG";
import storageActions from "app/utils/storageActions";
import store from "app/redux/store";

import {
  View,
  TouchableOpacity,
  StatusBar,
  Platform,
  ActivityIndicator,
  Keyboard,
  KeyboardAvoidingView,
  AppState,
} from "react-native";

import {
  NavigationContainer,
  DefaultTheme,
  DarkTheme,
  CommonActions,
  StackActions,
  DrawerActions,
} from "@react-navigation/native";
import { createStackNavigator } from "@react-navigation/stack";
import {
  createDrawerNavigator,
  DrawerContentScrollView,
  DrawerItemList,
  DrawerItem,
} from "@react-navigation/drawer";

import {
  Ionicons,
  MaterialCommunityIcons,
  MaterialIcons,
  AntDesign,
  FontAwesome5,
  Fontisto,
  Entypo,
  Octicons,
  Foundation,
  FontAwesome,
  Feather,
} from "@expo/vector-icons";

import {
  KeyboardAccessoryNavigation,
  KeyboardAccessoryView,
} from "react-native-keyboard-accessory";

import prefActions from "app/utils/prefActions";
import alertActions from "app/utils/alertActions";

import { navigationRef } from "app/utils/RootNavigation";
import * as RootNavigation from "app/utils/RootNavigation";
import ENV from "app/utils/ENV";
import { styleSheet } from "app/utils/styleSheet";
import notificationHelpers from "app/utils/notificationHelpers";
import colorHelpers from "app/utils/colorHelpers";
import keyboardHelpers from "app/utils/keyboardHelpers";

import KeyboardShortcuts from "app/components/KeyboardShortcuts";
import About from "app/components/About";
import SettingsModal from "app/components/SettingsModal";
import NarrativeModal from "app/components/NarrativeModal";

import Overview from "app/views/Overview";
import Mountain from "app/views/Mountain";
import TextView from "app/views/TextView";
import Chapters from "app/views/Chapters";
import ListChapters from "app/views/ListChapters";
import Chapter from "app/views/Chapter";
import MomentIndex from "app/views/MomentIndex";
import OverviewFocus from "app/views/OverviewFocus";
import Gears from "app/views/Gears";
// import Weaver from 'app/views/Weaver'
import Value from "app/views/Value";
import Intro from "app/views/Intro";
import List from "app/views/List";
import ToDo from "app/views/ToDo";
import Timeline from "app/views/Timeline";
import Agenda from "app/views/Agenda";
import Edit from "app/views/Edit";
import Revise from "app/views/Revise";
import Create from "app/views/Create";
// import Form from 'app/views/Form'
import Calendar from "app/views/Calendar";
import Tree from "app/views/Tree";
import Fractal from "app/views/Fractal";
import Map from "app/views/Map";
import Map2 from "app/views/Map2";
import Today from "app/views/Today";
import Network from "app/views/Network";
import IconTest from "app/views/IconTest";
import Workspace from "app/views/Workspace";
import Widget from "app/views/Widget";
import Focus from "app/views/Focus";
import Settings from "app/views/Settings";
import Profile from "app/views/Profile";

import HR from "app/components/shared/HR";

const Stack = createStackNavigator();
const Drawer = createDrawerNavigator();

import { StyleContext } from "app/contexts/Style";

export default class Router extends React.Component {
  static contextType = StyleContext;

  constructor(props, context) {
    super(props, context);
    let customTheme = this.customTheme(context);
    this.state = {
      showKeyboardShortcuts: false,
      showAbout: false,
      showSettings: false,
      customTheme,
      colorScheme: context.colorScheme,
      uiColor: context.uiColor,
      appState: AppState.currentState,
      lastThemeChangeAt: new Date().getTime(),
    };
  }

  componentDidMount() {
    this.subscribe();
    this.appStateListener = AppState.addEventListener(
      "change",
      this._handleAppStateChange,
    );
    if (ENV.WEB)
      document.addEventListener("keydown", keyboardHelpers.globalListener);
    keyboardHelpers.onToggleShortcuts = () =>
      this.setState((s) => ({ showKeyboardShortcuts: !s.showKeyboardShortcuts }));
  }

  _handleAppStateChange = (nextAppState) => {
    if (
      this.state.appState.match(/inactive|background/) &&
      nextAppState === "active"
    ) {
      if (new Date().getTime() - this.state.lastThemeChangeAt > 30 * 1000) {
        this.setState({
          customTheme: this.customTheme(),
          lastThemeChangeAt: new Date().getTime(),
        });
      }
    }
    this.setState({ appState: nextAppState });
  };

  componentWillUnmount() {
    this.unsubscribeRedux && this.unsubscribeRedux();
    this.appStateListener?.remove();
    if (ENV.WEB)
      document.removeEventListener("keydown", keyboardHelpers.globalListener);
    if (keyboardHelpers.onToggleShortcuts) keyboardHelpers.onToggleShortcuts = null;
  }

  subscribe = async () => {
    if (!!this.unsubscribeRedux) return;
    this.unsubscribeRedux = store.subscribe(() => {
      let { preferences } = store.getState();
      // console.log(this.context.colorScheme);
      if (
        this.context.colorScheme != this.state.colorScheme ||
        this.context.uiColor != this.state.uiColor
      ) {
        this.setState({
          colorScheme: this.context.colorScheme,
          uiColor: this.context.uiColor,
          customTheme: this.customTheme(),
        });
      }
    });
  };

  customTheme = (context = null) => {
    if (!context) context = this.context;
    let baseTheme = ENV.DARK ? DarkTheme : DefaultTheme;
    let c = context.colors;
    let headerColor = c.fill;
    let headerColorKey = null;
    if (context?.uiColor == "default") {
      headerColorKey = "default";
      headerColor = c.fill;
    } else if (context.colorScheme == "clarity") {
      let allColors = colorHelpers.allColors(context.colorScheme);
      if (!!context.uiColor) {
        headerColorKey = context.uiColor;
      } else {
        let exclude = ["cream", "white", "gray", "black"];
        let colorNames = Object.keys(allColors).filter(
          (n) => !exclude.includes(n),
        );
        headerColorKey =
          colorNames[Math.floor(Math.random() * colorNames.length)];
      }
      headerColor = allColors[headerColorKey];
    }
    return {
      ...baseTheme,
      colors: {
        ...baseTheme.colors,
        background: c.empty,
        card: headerColor,
        border: c.trim,
        border: "transparent",
        text: this.headerTintColor(context, headerColorKey, headerColor),
        primary: c.active,
      },
      headerColor,
      headerColorKey,
    };
  };

  render() {
    let { showKeyboardShortcuts, showAbout, showSettings } = this.state;
    {
      /*<View
        style={{
          flex: 1,
          borderTopWidth: 1,
          borderColor: this.context.colors.trim,
        }}
      >*/
    }

    let drawerColor = this.headerTintColor();

    let drawerActiveTintColor = drawerColor;
    let drawerInactiveTintColor = drawerColor;
    // let drawerActiveBackgroundColor;
    // let drawerInactiveBackgroundColor;
    // if (this.state.colorScheme == "clarity") {
    //   drawerActiveBackgroundColor = colorHelpers.hexToRgbaString(
    //     this.context.colors.foreground,
    //     0.2
    //   );
    //   drawerInactiveBackgroundColor = colorHelpers.hexToRgbaString(
    //     this.context.colors.foreground,
    //     0.05
    //   );
    // }

    return (
      <View
        style={{
          flex: 1,
          backgroundColor: this.context.colors.empty,
          // backgroundColor: "red",
        }}
      >
        {/*<KeyboardAvoidingView
          enabled
          behavior={"padding"}
          behavior={"height"}
          // keyboardShouldPersistTaps={"handled"}
          keyboardShouldPersistTaps={"always"}
          style={{ flex: 1 }}
          // keyboardVerticalOffset={60}
        >*/}
        <NavigationContainer
          theme={this.state.customTheme}
          ref={navigationRef}
          linking={Linking}
          drawerPosition={ENV.WEB ? "left" : "right"}
        >
          <Drawer.Navigator
            initialRouteName={"Chapters"}
            drawerPosition={ENV.WEB ? "left" : "right"}
            drawerStyle={{
              // backgroundColor: '#c6cbef',
              width: 220,
            }}
            screenOptions={{
              //   gestureEnabled: false,
              headerShown: false,
              //   swipeEnabled: false
              ...this.headerOptions(),
            }}
            // swipeEnabled={false}
            // gestureEnabled={false}
            // headerShown={false}
            drawerContent={(props) => {
              let currentRoute = props.state.routeNames[props.state.index];
              return (
                <DrawerContentScrollView {...props}>
                  <DrawerItem
                    label="Mandelbrot"
                    activeTintColor={drawerActiveTintColor}
                    inactiveTintColor={drawerInactiveTintColor}
                    // activeBackgroundColor={drawerActiveBackgroundColor}
                    // inactiveBackgroundColor={drawerInactiveBackgroundColor}
                    icon={({ focused, color, size }) => (
                      <Entypo
                        color={color}
                        size={size}
                        name={focused ? "home" : "home"}
                      />
                    )}
                    onPress={() => {
                      props.navigation.dispatch(StackActions.popToTop());
                      props.navigation.dispatch(DrawerActions.closeDrawer());
                    }}
                  />

                  <HR color={this.headerTintColor()} opacity={0.25} />

                  {/*<DrawerItemList {...props} />*/}

                  <DrawerItem
                    label="Chapters"
                    activeTintColor={drawerActiveTintColor}
                    inactiveTintColor={drawerInactiveTintColor}
                    // activeBackgroundColor={drawerActiveBackgroundColor}
                    // inactiveBackgroundColor={drawerInactiveBackgroundColor}
                    focused={currentRoute == "Chapters"}
                    icon={({ focused, color, size }) => (
                      <Entypo color={color} size={size} name={"open-book"} />
                    )}
                    onPress={(e) => {
                      RootNavigation.navigate("Chapters", {}, e);
                      props.navigation.dispatch(DrawerActions.closeDrawer());
                    }}
                  />

                  <DrawerItem
                    label="Mountain"
                    activeTintColor={drawerActiveTintColor}
                    inactiveTintColor={drawerInactiveTintColor}
                    focused={currentRoute == "Mountain"}
                    icon={({ focused, color, size }) => (
                      <Foundation
                        color={color}
                        size={size}
                        name={"mountains"}
                      />
                    )}
                    onPress={(e) => {
                      RootNavigation.navigate("Mountain", {}, e);
                      props.navigation.dispatch(DrawerActions.closeDrawer());
                    }}
                  />

                  {/*<DrawerItem
                    label="List Chapters"
                    activeTintColor={drawerActiveTintColor}
                    inactiveTintColor={drawerInactiveTintColor}
                    // activeBackgroundColor={drawerActiveBackgroundColor}
                    // inactiveBackgroundColor={drawerInactiveBackgroundColor}
                    focused={currentRoute == "ListChapters"}
                    icon={({ focused, color, size }) => (
                      <Entypo color={color} size={size} name={"open-book"} />
                    )}
                    onPress={(e) => {
                      RootNavigation.navigate("ListChapters", {}, e);
                      props.navigation.dispatch(DrawerActions.closeDrawer());
                    }}
                  />*/}

                  <DrawerItem
                    label="Overview"
                    activeTintColor={drawerActiveTintColor}
                    inactiveTintColor={drawerInactiveTintColor}
                    // activeBackgroundColor={drawerActiveBackgroundColor}
                    // inactiveBackgroundColor={drawerInactiveBackgroundColor}
                    focused={currentRoute == "Overview"}
                    icon={({ focused, color, size }) => (
                      <Entypo color={color} size={size} name={"list"} />
                    )}
                    onPress={(e) => {
                      RootNavigation.navigate("Overview", {}, e);
                      props.navigation.dispatch(DrawerActions.closeDrawer());
                    }}
                  />

                  <DrawerItem
                    label="Profile"
                    activeTintColor={drawerActiveTintColor}
                    inactiveTintColor={drawerInactiveTintColor}
                    focused={currentRoute == "Profile"}
                    icon={({ focused, color, size }) => (
                      <Feather color={color} size={size} name={"user"} />
                    )}
                    onPress={(e) => {
                      RootNavigation.navigate("Profile", {}, e);
                      props.navigation.dispatch(DrawerActions.closeDrawer());
                    }}
                  />

                  <DrawerItem
                    label="Widget"
                    activeTintColor={drawerActiveTintColor}
                    inactiveTintColor={drawerInactiveTintColor}
                    // activeBackgroundColor={drawerActiveBackgroundColor}
                    // inactiveBackgroundColor={drawerInactiveBackgroundColor}
                    focused={currentRoute == "Widget"}
                    icon={({ focused, color, size }) => (
                      <MaterialCommunityIcons
                        color={color}
                        size={size}
                        name="gauge-full"
                      />
                    )}
                    onPress={(e) => {
                      RootNavigation.navigate("Widget", {}, e);
                      props.navigation.dispatch(DrawerActions.closeDrawer());
                    }}
                  />

                  <DrawerItem
                    label="ToDo"
                    activeTintColor={drawerActiveTintColor}
                    inactiveTintColor={drawerInactiveTintColor}
                    // activeBackgroundColor={drawerActiveBackgroundColor}
                    // inactiveBackgroundColor={drawerInactiveBackgroundColor}
                    focused={currentRoute == "ToDo"}
                    icon={({ focused, color, size }) => (
                      <Feather
                        color={color}
                        size={size}
                        name={"check-square"}
                      />
                    )}
                    onPress={(e) => {
                      RootNavigation.navigate("ToDo", {}, e);
                      props.navigation.dispatch(DrawerActions.closeDrawer());
                    }}
                  />

                  <DrawerItem
                    label="Agenda"
                    activeTintColor={drawerActiveTintColor}
                    inactiveTintColor={drawerInactiveTintColor}
                    // activeBackgroundColor={drawerActiveBackgroundColor}
                    // inactiveBackgroundColor={drawerInactiveBackgroundColor}
                    focused={currentRoute == "Agenda"}
                    icon={({ focused, color, size }) => (
                      <MaterialCommunityIcons
                        color={color}
                        size={size}
                        name={"view-day-outline"}
                      />
                    )}
                    onPress={(e) => {
                      RootNavigation.navigate("Agenda", {}, e);
                      props.navigation.dispatch(DrawerActions.closeDrawer());
                    }}
                  />

                  {ENV.WEB && (
                    <DrawerItem
                      label="Node Map"
                      activeTintColor={drawerActiveTintColor}
                      inactiveTintColor={drawerInactiveTintColor}
                      // activeBackgroundColor={drawerActiveBackgroundColor}
                      // inactiveBackgroundColor={drawerInactiveBackgroundColor}
                      focused={currentRoute == "Map"}
                      icon={({ focused, color, size }) => (
                        <Entypo color={color} size={size} name={"flow-tree"} />
                      )}
                      onPress={(e) => {
                        RootNavigation.navigate("Map", {}, e);
                        props.navigation.dispatch(DrawerActions.closeDrawer());
                      }}
                    />
                  )}

                  {ENV.WEB && (
                    <HR color={this.headerTintColor()} opacity={0.25} />
                  )}
                  <DrawerItem
                    label="Tutorial"
                    activeTintColor={drawerActiveTintColor}
                    inactiveTintColor={drawerInactiveTintColor}
                    // activeBackgroundColor={drawerActiveBackgroundColor}
                    // inactiveBackgroundColor={drawerInactiveBackgroundColor}
                    icon={({ focused, color, size }) => (
                      <Entypo
                        color={color}
                        size={size}
                        name={"help-with-circle"}
                      />
                    )}
                    onPress={(e) => {
                      RootNavigation.navigate("Intro", {}, e);
                      props.navigation.dispatch(DrawerActions.closeDrawer());
                    }}
                  />
                  {/*<DrawerItem
                    label="About"
                    icon={({ focused, color, size }) => (
                      <Entypo color={color} size={size} name={"help"} />
                    )}
                    onPress={() => {
                      this.setState({ showAbout: true });
                      props.navigation.dispatch(DrawerActions.closeDrawer());
                    }}
                  />*/}
                  {ENV.WEB && (
                    <DrawerItem
                      label="Shortcuts"
                      activeTintColor={drawerActiveTintColor}
                      inactiveTintColor={drawerInactiveTintColor}
                      // activeBackgroundColor={drawerActiveBackgroundColor}
                      // inactiveBackgroundColor={drawerInactiveBackgroundColor}
                      icon={({ focused, color, size }) => (
                        <Entypo color={color} size={size} name={"keyboard"} />
                      )}
                      onPress={() => {
                        this.setState({ showKeyboardShortcuts: true });
                        props.navigation.dispatch(DrawerActions.closeDrawer());
                      }}
                    />
                  )}
                  <DrawerItem
                    label="Settings"
                    activeTintColor={drawerActiveTintColor}
                    inactiveTintColor={drawerInactiveTintColor}
                    // activeBackgroundColor={drawerActiveBackgroundColor}
                    // inactiveBackgroundColor={drawerInactiveBackgroundColor}
                    focused={currentRoute == "Settings"}
                    icon={({ focused, color, size }) => (
                      <Octicons color={color} size={size} name={"gear"} />
                    )}
                    onPress={() => {
                      // RootNavigation.navigate("Settings");
                      this.setState({ showSettings: true });
                      props.navigation.dispatch(DrawerActions.closeDrawer());
                    }}
                  />
                  <HR color={this.headerTintColor()} opacity={0.25} />
                  <DrawerItem
                    label="Log Out"
                    activeTintColor={drawerActiveTintColor}
                    inactiveTintColor={drawerInactiveTintColor}
                    // activeBackgroundColor={drawerActiveBackgroundColor}
                    // inactiveBackgroundColor={drawerInactiveBackgroundColor}
                    icon={({ focused, color, size }) => (
                      <Entypo color={color} size={size} name={"log-out"} />
                    )}
                    onPress={async () => {
                      let confirm = await alertActions.confirm({
                        text: "Log Out",
                      });
                      if (confirm) {
                        await storageActions.clearAll();
                        this.props.clearToken();
                      }
                    }}
                  />
                </DrawerContentScrollView>
              );
            }}
          >
            <Drawer.Screen name="Widget" component={this.WidgetStack} />
            <Drawer.Screen name="Gears" component={this.GearsStack} />
            {/*
                <Drawer.Screen name="Focus" component={this.FocusStack} />
                <Drawer.Screen name="List" component={this.ListStack} />
                <Drawer.Screen name="Overview" component={OverviewStack} />*/}
            <Drawer.Screen name="Chapters" component={this.ChaptersStack} />
            <Drawer.Screen
              name="ListChapters"
              component={this.ListChaptersStack}
            />
            <Drawer.Screen name="ToDo" component={this.ToDoStack} />
            <Drawer.Screen name="Agenda" component={this.AgendaStack} />
            <Drawer.Screen name="Profile" component={this.ProfileStack} />
            <Drawer.Screen
              name="Overview"
              component={this.TextViewStack}
              options={{
                headerTitle: "Overview",
                title: "Overview",
              }}
            />
            <Drawer.Screen
              name="Mountain"
              component={this.MountainStack}
              options={{
                headerTitle: "Mountain",
                title: "Mountain",
              }}
            />
            {/*<Drawer.Screen name="OverviewFocus" component={this.OverviewFocusStack} />*/}
            {/*<Drawer.Screen name="Weaver" component={this.WeaverStack} />*/}
            {/*<Drawer.Screen name="Timeline" component={this.TimelineStack} />*/}
            {<Drawer.Screen name="Tree" component={this.TreeStack} />}
            <Drawer.Screen name="Fractal" component={this.FractalStack} />
            <Drawer.Screen name="Map" component={this.MapStack} />
            {/*ENV.WEB && (
                  <Drawer.Screen name="Calendar" component={this.CalendarStack} />
                )*/}

            <Drawer.Screen name="Settings" component={this.SettingsStack} />

            {ENV.WEB && (
              <Drawer.Screen name="Map2" component={this.Map2Stack} />
            )}
            {/*<Drawer.Screen name="Today" component={this.TodayStack} />*/}
            {ENV.WEB && (
              <Drawer.Screen name="Network" component={this.NetworkStack} />
            )}
            {/*!ENV.LOCAL && <Drawer.Screen name="Workspace" component={this.WorkspaceStack} />*/}
            {/*
             */}
            <Drawer.Screen name="IconTest" component={this.IconTestStack} />
          </Drawer.Navigator>
          <StatusBar barStyle="light-content" />
        </NavigationContainer>

        {showKeyboardShortcuts && (
          <KeyboardShortcuts
            onHide={() => this.setState({ showKeyboardShortcuts: false })}
          />
        )}
        {showAbout && (
          <About onHide={() => this.setState({ showAbout: false })} />
        )}
        {showSettings && (
          <SettingsModal
            onHide={() => this.setState({ showSettings: false })}
          />
        )}
        {!!this.context.narrativeChapter && (
          <NarrativeModal
            chapter={this.context.narrativeChapter}
            onClose={this.context.closeNarrative}
            onSaved={() => this.context.narrativeOnSaved?.()}
          />
        )}
        {/*</KeyboardAvoidingView>*/}
        {!ENV.WEB && (
          <KeyboardAccessoryNavigation
            // alwaysVisible={false}
            // inSafeAreaView
            hideBorder
            style={{
              backgroundColor: this.context.colors.fill,
              minHeight: 70,
              padding: this.context.sizes.tiny,
              // justifyContent: "center",
            }}
            ref={(r) => (this.ref = r)}
            previousButton={this.renderLeftKeyboardAccButtons()}
            nextButton={() => null}
            doneButton={
              <View style={{ flexDirection: "row" }}>
                {(true || this.context.asdfasdf) && (
                  <Text
                    selectedButton
                    onPress={() => {
                      store.dispatch({
                        type: "listeners/event",
                        event: "meta_k",
                      });
                    }}
                  >
                    Strike
                  </Text>
                )}
                <Text selectedButton style={{ marginRight: 0 }}>
                  Done
                </Text>
              </View>
            }
          />
        )}
      </View>
    );
  }

  renderLeftKeyboardAccButtons = () => {
    let { keyboardAccType, selectedText } = this.context;
    if (keyboardAccType == "scratchpad") {
      let hasSelection = !!selectedText?.length;
      if (hasSelection) {
        return (
          <View style={{ flexDirection: "row" }}>
            <Text
              disabled={!hasSelection}
              selectedButton //={hasSelection}
              onPress={() => {
                this.context.createFromSelection();
              }}
            >
              Create
            </Text>
          </View>
        );
      } else {
        return (
          <View style={{ flexDirection: "row" }}>
            <Text
              selectedButton
              style={{ marginRight: 0 }}
              onPress={() => {
                store.dispatch({
                  type: "listeners/event",
                  event: "tab",
                });
              }}
            >
              ⇥
            </Text>
          </View>
        );
      }
    } else {
      return (
        <View style={{ flexDirection: "row" }}>
          <Text
            selectedButton
            // style={{ marginRight: 0 }}
            onPress={() => {
              store.dispatch({
                type: "listeners/event",
                event: "arrow_up",
              });
            }}
          >
            <Feather name={`chevron-up`} />
          </Text>
          <Text
            selectedButton
            // style={{ marginRight: 0 }}
            onPress={() => {
              store.dispatch({
                type: "listeners/event",
                event: "arrow_down",
              });
            }}
          >
            <Feather name={`chevron-down`} />
          </Text>
          <Text
            selectedButton
            style={{ marginRight: 0 }}
            onPress={() => {
              store.dispatch({
                type: "listeners/event",
                event: "tab",
              });
            }}
          >
            ⇥
          </Text>
        </View>
      );
    }
  };

  headerOptions = () => {
    // console.log("setting header options");
    return {
      headerRight: this.headerRight,
      // headerLeft: this.headerLeft,
      headerTitle: this.headerLogo,
      cardStyle: { flex: 1 },
      drawerPosition: ENV.WEB ? "left" : "right",
      drawerStyle: {
        width: 220,
      },
    };
  };

  headerTintColor = (
    context = null,
    headerColorKey = null,
    headerColor = null,
  ) => {
    if (!headerColorKey) {
      headerColorKey = this?.state?.customTheme?.headerColorKey;
      headerColor = this?.state?.customTheme?.headerColor;
    }
    let colorScheme, colors;
    if (!!context) {
      colorScheme = context.colorScheme;
      colors = context.colors;
    } else {
      colorScheme = this.state.colorScheme;
      colors = this.context.colors;
    }
    let brightBG = [
      "yellow",
      "cyan",
      "viridian",
      "lime",
      "cream",
      "white",
      "gray",
      "default",
    ].includes(headerColorKey);
    if (colorScheme == "clarity" && brightBG) {
      return colorHelpers.modifyHex(headerColor, 0.6);
    }
    return colorScheme == "clarity"
      ? brightBG
        ? colors.darkForeground
        : colors.lightForeground
      : colors.foreground;
  };

  headerRight = () => {
    return (
      <TouchableOpacity onPress={RootNavigation.toggleDrawer}>
        <Ionicons
          name="menu"
          size={32}
          color={this.headerTintColor()}
          style={{ marginRight: 20 }}
        />
      </TouchableOpacity>
    );
  };

  headerLeft = () => {
    return (
      <TouchableOpacity onPress={RootNavigation.popToTop}>
        <View style={{ marginLeft: 26 }}>
          <LogoSVG color={this.headerTintColor()} />
        </View>
        {/*<Ionicons
          name="ios-menu"
          size={32}
          color={this.context.colors.foreground}
          style={{ marginLeft: 20 }}
        />*/}
      </TouchableOpacity>
    );
  };

  headerLogo = () => {
    return (
      <TouchableOpacity onPress={RootNavigation.popToTop}>
        <LogoSVG color={this.headerTintColor()} />
      </TouchableOpacity>
    );
  };

  ChaptersStack = () => {
    return (
      <Stack.Navigator
        screenOptions={{
          ...this.headerOptions(),
        }}
        initialRouteName={!!this.props.intro ? "Intro" : "Chapters"}
      >
        <Stack.Screen name="Chapters" component={Chapters} />
        <Stack.Screen name="Chapter" component={Chapter} />
        <Stack.Screen name="Intro" component={Intro} />
        <Stack.Screen name="MomentIndex" component={MomentIndex} />
        <Drawer.Screen
          name="Value"
          component={Value}
          initialParams={{ id: this.props.valueId }}
        />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Revise" component={Revise} />
        <Drawer.Screen name="Create" component={Create} />
      </Stack.Navigator>
    );
  };

  ListChaptersStack = () => {
    return (
      <Stack.Navigator
        screenOptions={{
          ...this.headerOptions(),
        }}
        initialRouteName={"ListChapters"}
      >
        <Stack.Screen name="ListChapters" component={ListChapters} />
        <Stack.Screen name="Chapter" component={Chapter} />
        <Drawer.Screen
          name="Value"
          component={Value}
          initialParams={{ id: this.props.valueId }}
        />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Revise" component={Revise} />
        <Drawer.Screen name="Create" component={Create} />
      </Stack.Navigator>
    );
  };

  OverviewStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="Overview" component={Overview} />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Revise" component={Revise} />
        <Drawer.Screen name="Create" component={Create} />
      </Stack.Navigator>
    );
  };

  ProfileStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="Profile" component={Profile} />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Chapter" component={Chapter} />
      </Stack.Navigator>
    );
  };

  TextViewStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen
          name="TextView"
          component={TextView}
          options={{
            headerTitle: "Overview",
          }}
        />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Revise" component={Revise} />
        <Drawer.Screen name="Create" component={Create} />
      </Stack.Navigator>
    );
  };

  MountainStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen
          name="Mountain"
          component={Mountain}
          options={{
            headerTitle: "Mountain",
          }}
        />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Revise" component={Revise} />
        <Drawer.Screen name="Create" component={Create} />
      </Stack.Navigator>
    );
  };

  OverviewFocusStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="OverviewFocus" component={OverviewFocus} />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Revise" component={Revise} />
        <Drawer.Screen name="Create" component={Create} />
      </Stack.Navigator>
    );
  };

  FocusStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="Focus" component={Focus} />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Revise" component={Revise} />
        <Drawer.Screen name="Create" component={Create} />
      </Stack.Navigator>
    );
  };

  GearsStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="Gears" component={Gears} />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Revise" component={Revise} />
        <Drawer.Screen name="Create" component={Create} />
      </Stack.Navigator>
    );
  };

  ListStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="List" component={List} />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Revise" component={Revise} />
        <Drawer.Screen name="Create" component={Create} />
      </Stack.Navigator>
    );
  };

  ToDoStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="ToDo" component={ToDo} />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Revise" component={Revise} />
        <Drawer.Screen name="Create" component={Create} />
        <Drawer.Screen name="List" component={List} />
      </Stack.Navigator>
    );
  };

  AgendaStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="Agenda" component={Agenda} />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Revise" component={Revise} />
        <Drawer.Screen name="Create" component={Create} />
        <Drawer.Screen name="Chapter" component={Chapter} />
      </Stack.Navigator>
    );
  };

  CalendarStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="Calendar" component={Calendar} />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Create" component={Create} />
        <Drawer.Screen name="Revise" component={Revise} />
        <Drawer.Screen name="List" component={List} />
      </Stack.Navigator>
    );
  };

  TimelineStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="Timeline" component={Timeline} />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Create" component={Create} />
        <Drawer.Screen name="Revise" component={Revise} />
      </Stack.Navigator>
    );
  };

  TreeStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="Tree" component={Tree} />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Create" component={Create} />
        <Drawer.Screen name="Revise" component={Revise} />
      </Stack.Navigator>
    );
  };

  FractalStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="Fractal" component={Fractal} />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Create" component={Create} />
        <Drawer.Screen name="Revise" component={Revise} />
      </Stack.Navigator>
    );
  };

  MapStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="Map" component={Map} />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Create" component={Create} />
        <Drawer.Screen name="Revise" component={Revise} />
      </Stack.Navigator>
    );
  };

  Map2Stack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="Map2" component={Map2} />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Create" component={Create} />
        <Drawer.Screen name="Revise" component={Revise} />
      </Stack.Navigator>
    );
  };

  TodayStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="Today" component={Today} />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Create" component={Create} />
        <Drawer.Screen name="Revise" component={Revise} />
      </Stack.Navigator>
    );
  };

  NetworkStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="Network" component={Network} />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Create" component={Create} />
        <Drawer.Screen name="Revise" component={Revise} />
      </Stack.Navigator>
    );
  };

  IconTestStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="IconTest" component={IconTest} />
      </Stack.Navigator>
    );
  };

  WorkspaceStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="Workspace" component={Workspace} />
      </Stack.Navigator>
    );
  };

  WidgetStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="Widget" component={Widget} />
        <Drawer.Screen name="Value" component={Value} />
        <Drawer.Screen name="Edit" component={Edit} />
        <Drawer.Screen name="Create" component={Create} />
        <Drawer.Screen name="Revise" component={Revise} />
      </Stack.Navigator>
    );
  };

  SettingsStack = () => {
    return (
      <Stack.Navigator screenOptions={{ ...this.headerOptions() }}>
        <Stack.Screen name="Settings" component={Settings} />
      </Stack.Navigator>
    );
  };
}

const Linking = {
  // prefixes: ['https://mychat.com', 'mychat://'],
  enabled: true,
  // config: {
  //   screens: {
  //     // Overview: '',
  //     Profile: ':id/profile',
  //     Settings: ':id/blog',
  //     // Value: ':id/value',
  //   }
  // },
};
